(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["postal-automovil-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const engineKey = "__postalAutomovilAnimationEngineV16";
  const engineVersion = "v16";

  if (window[engineKey] && typeof window[engineKey].boot === "function") {
    window[engineKey].boot(document);
    return;
  }

  const clamp = (value, min = 0, max = 1) => Math.min(Math.max(value, min), max);
  const range = (value, start, end) => clamp((value - start) / (end - start));
  const ease = (value) => 1 - Math.pow(1 - value, 3);
  const smooth = (value) => value * value * (3 - 2 * value);

  function viewportHeight() {
    return Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0, 1);
  }

  function stickyProgress(section, lead = 0) {
    const rect = section.getBoundingClientRect();
    const viewport = viewportHeight();
    const scrollable = Math.max(rect.height - viewport, viewport * 0.65, 1);
    return clamp((viewport * lead - rect.top) / scrollable);
  }

  function initialise(root) {
    if (!root) return;

    if (
      root.dataset.paInitialised === "true"
      && root.dataset.paAnimationEngine === engineVersion
    ) {
      if (typeof root.paRequestRender === "function") root.paRequestRender();
      return;
    }

    /*
     * Shopify puede conservar en memoria una version anterior del script al
     * recargar la seccion en el editor. La apagamos antes de instalar V16 para
     * que nunca queden dos motores compitiendo por los mismos estilos.
     */
    if (typeof root.paDestroy === "function") root.paDestroy();

    root.dataset.paEnhanced = "true";
    root.dataset.paInitialised = "true";
    root.dataset.paAnimationEngine = engineVersion;

    const motionMode = root.dataset.paMotion || "always";
    const systemRequestsReducedMotion = typeof window.matchMedia === "function"
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const reducedMotion = motionMode === "off"
      || (motionMode === "system" && systemRequestsReducedMotion);
    const header = root.querySelector("[data-pa-header]");
    const pageProgress = root.querySelector("[data-pa-page-progress]");
    const hero = root.querySelector(".pa-hero");
    const heroImage = root.querySelector(".pa-hero-image");
    const unboxing = root.querySelector("[data-pa-unboxing]");
    const unboxingScene = root.querySelector("[data-pa-unboxing-scene]");
    const envelope = root.querySelector("[data-pa-envelope]");
    const envelopeFlap = root.querySelector("[data-pa-envelope-flap]");
    const unboxingProgress = root.querySelector("[data-pa-unboxing-progress]");
    const stageTitles = Array.from(root.querySelectorAll("[data-pa-stage]"));
    const items = Array.from(root.querySelectorAll("[data-pa-item]"));
    const pieceTotal = items.length
      ? Number(items[items.length - 1].dataset.pieceEnd || items.length)
      : 9;
    const pieceNumber = root.querySelector("[data-pa-piece-number]");
    const pieceLabel = root.querySelector("[data-pa-piece-label]");
    const garage = root.querySelector("[data-pa-garage]");
    const garageDoor = root.querySelector("[data-pa-garage-door]");
    const garageLights = root.querySelector("[data-pa-garage-lights]");
    const garageMessage = root.querySelector("[data-pa-garage-message]");

    let frame = 0;
    let running = true;
    let forceRender = true;
    let lastRenderTime = -Infinity;
    let currentStage = -1;
    let currentItem = -1;
    let garageIsOpen = false;

    function renderHeaderAndHero() {
      const rootTop = root.getBoundingClientRect().top;
      const rootScrollable = Math.max(root.offsetHeight - window.innerHeight, 1);
      const rootProgress = clamp(-rootTop / rootScrollable);

      if (header) header.classList.toggle("is-scrolled", rootTop < -36);
      if (pageProgress) pageProgress.style.transform = `scaleX(${rootProgress})`;

      if (hero && heroImage && !reducedMotion) {
        const heroRect = hero.getBoundingClientRect();
        const progress = clamp(-heroRect.top / Math.max(heroRect.height, 1));
        heroImage.style.setProperty("--pa-hero-shift", `${progress * 44}px`);
      }
    }

    function renderUnboxing() {
      if (!unboxing || !unboxingScene || !envelope || !envelopeFlap) return;

      const progress = reducedMotion ? 1 : stickyProgress(unboxing);
      const arrive = ease(range(progress, 0.02, 0.17));
      const open = ease(range(progress, 0.17, 0.42));
      const envelopeExit = ease(range(progress, 0.92, 1));
      const isMobile = window.innerWidth < 700;

      envelopeFlap.style.transform = `rotateX(${-176 * open}deg)`;
      envelopeFlap.style.zIndex = open > 0.48 ? "1" : "6";
      envelope.style.transform = `translate3d(-50%, calc(-50% + ${(1 - arrive) * 150 + envelopeExit * 44}px), 0) rotate(${(1 - arrive) * -4}deg) scale(${0.84 + arrive * 0.16 - envelopeExit * 0.05})`;
      envelope.style.opacity = `${0.15 + arrive * 0.85 - envelopeExit * 0.22}`;
      unboxingScene.style.setProperty("--pa-scene-glow", `${0.16 + open * 0.5}`);
      if (unboxingProgress) unboxingProgress.style.transform = `scaleX(${progress})`;

      items.forEach((item, index) => {
        if (isMobile) {
          const itemPosition = range(progress, 0.34, 0.94) * Math.max(items.length - 0.12, 0);
          const phase = itemPosition - index;
          const entry = ease(clamp(phase * 3.5));
          const exit = index === items.length - 1 ? 0 : ease(clamp((phase - 0.72) * 3.5));
          const opacity = entry * (1 - exit);
          const y = 104 - entry * 180 - exit * 72;
          const rotation = (index % 2 === 0 ? -2.2 : 2.2) * entry;
          const scale = 0.72 + entry * 0.28 - exit * 0.06;

          item.style.transform = `translate3d(-50%, calc(-50% + ${y}px), 0) rotate(${rotation}deg) scale(${scale})`;
          item.style.opacity = `${opacity}`;
          item.style.zIndex = `${15 + index}`;
          item.style.setProperty("--pa-label-opacity", `${opacity}`);
        } else {
          const local = ease(range(progress, 0.27 + index * 0.038, 0.66 + index * 0.028));
          const targetX = Number(item.dataset.x || 0);
          const targetY = Number(item.dataset.y || 0);
          const targetRotation = Number(item.dataset.rotate || 0);
          const x = targetX * local;
          const arc = Math.sin(local * Math.PI) * 84;
          const y = 116 * (1 - local) + targetY * local - arc;
          const rotation = targetRotation * local;
          const scale = 0.58 + local * 0.42;
          const visible = clamp(local * 7);

          item.style.transform = `translate3d(calc(-50% + ${x}px), calc(-50% + ${y}px), 0) rotate(${rotation}deg) scale(${scale})`;
          item.style.opacity = `${visible}`;
          item.style.zIndex = `${12 + index}`;
          item.style.setProperty("--pa-label-opacity", `${range(progress, 0.64 + index * 0.012, 0.8 + index * 0.01)}`);
        }
      });

      const nextItem = Math.min(Math.floor(range(progress, 0.34, 0.94) * items.length), items.length - 1);
      if (nextItem !== currentItem && items[nextItem]) {
        currentItem = nextItem;
        const pieceEnd = Number(items[nextItem].dataset.pieceEnd || nextItem + 1);
        if (pieceNumber) pieceNumber.textContent = `${String(pieceEnd).padStart(2, "0")} / ${String(pieceTotal).padStart(2, "0")}`;
        if (pieceLabel) pieceLabel.textContent = items[nextItem].dataset.label || "";
      }

      const nextStage = progress < 0.18 ? 0 : progress < 0.43 ? 1 : progress < 0.82 ? 2 : 3;
      if (nextStage !== currentStage) {
        currentStage = nextStage;
        stageTitles.forEach((title, index) => {
          title.classList.toggle("is-active", index === nextStage);
          title.setAttribute("aria-hidden", index === nextStage ? "false" : "true");
        });
      }
    }

    function renderGarage() {
      if (!garage || !garageDoor || !garageLights) return;

      /*
       * El garaje entra completamente cerrado. La apertura comienza solo
       * cuando la escena ya esta fijada en pantalla y termina antes de salir,
       * dejando tiempo suficiente para ver el coche y sus faros.
       */
      const garageRect = garage.getBoundingClientRect();
      const garageTravel = Math.max(garageRect.height - viewportHeight(), 1);
      const pinnedProgress = clamp(-garageRect.top / garageTravel);
      const opening = reducedMotion ? 0.48 : smooth(range(pinnedProgress, 0.08, 0.8));

      garageDoor.style.transform = `translate3d(0, ${opening * -48}%, 0)`;
      garageLights.style.opacity = `${0.08 + opening * 0.92}`;

      // El mensaje aparece cuando la placa de la puerta ya ha atravesado la
      // zona del titular, evitando que ambos textos se superpongan.
      const nextOpen = opening > 0.9;
      if (nextOpen !== garageIsOpen) {
        garageIsOpen = nextOpen;
        if (garageMessage) garageMessage.classList.toggle("is-visible", nextOpen);
      }
    }

    function render() {
      if (!running || !document.documentElement.contains(root)) return;
      renderHeaderAndHero();
      renderUnboxing();
      renderGarage();
    }

    function requestRender() {
      forceRender = true;
      if (!frame && running) frame = window.requestAnimationFrame(animationLoop);
    }

    /*
     * En movil el navegador emite eventos scroll continuamente. Algunos temas
     * de Shopify para escritorio usan smooth-scroll o transformaciones y solo
     * emiten uno (o ninguno). Este muestreo mantiene las animaciones ligadas a
     * la posicion visual real en ambos casos.
     */
    function animationLoop(timestamp) {
      frame = 0;
      if (!running || !document.documentElement.contains(root)) return;

      if (!document.hidden && (forceRender || timestamp - lastRenderTime >= 16)) {
        forceRender = false;
        lastRenderTime = timestamp;
        render();
      }

      if (running) frame = window.requestAnimationFrame(animationLoop);
    }

    let revealObserver = null;
    const revealNodes = Array.from(root.querySelectorAll("[data-pa-reveal]"));

    if (reducedMotion || !("IntersectionObserver" in window)) {
      revealNodes.forEach((node) => node.classList.add("is-visible"));
    } else {
      revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.13, rootMargin: "0px 0px -5%" }
      );

      revealNodes.forEach((node) => revealObserver.observe(node));
    }

    root.querySelectorAll("[data-pa-plan-option]").forEach((option) => {
      const syncSelectedPlan = () => {
        if (!option.checked || option.disabled) return;
        const form = option.closest("form");
        if (!form) return;

        const variantInput = form.querySelector("[data-pa-plan-variant]");
        if (variantInput && option.dataset.paVariantId) {
          variantInput.value = option.dataset.paVariantId;
        }

        const button = form.querySelector("[data-pa-plan-submit]");
        if (!button) return;
        const available = option.dataset.paAvailable === "true";
        button.disabled = !available;
        const label = button.querySelector("span");
        if (label) label.textContent = available ? "Suscribirme ahora" : "Agotado";
      };

      option.addEventListener("change", syncSelectedPlan);
      syncSelectedPlan();
    });

    root.querySelectorAll(".pa-product-form").forEach((form) => {
      if (form.tagName !== "FORM") return;
      form.addEventListener("submit", () => {
        const button = form.querySelector("button[type='submit']");
        if (!button) return;
        button.classList.add("is-loading");
        button.disabled = true;
        const label = button.querySelector("span");
        if (label) label.textContent = "Añadiendo al carrito…";
      });
    });

    render();
    window.addEventListener("scroll", requestRender, { passive: true });
    document.addEventListener("scroll", requestRender, { passive: true, capture: true });
    window.addEventListener("resize", requestRender);
    window.addEventListener("orientationchange", requestRender);
    document.addEventListener("visibilitychange", requestRender);
    root.paRequestRender = requestRender;
    frame = window.requestAnimationFrame(animationLoop);

    root.paDestroy = () => {
      running = false;
      if (frame) window.cancelAnimationFrame(frame);
      if (revealObserver) revealObserver.disconnect();
      window.removeEventListener("scroll", requestRender);
      document.removeEventListener("scroll", requestRender, true);
      window.removeEventListener("resize", requestRender);
      window.removeEventListener("orientationchange", requestRender);
      document.removeEventListener("visibilitychange", requestRender);
      delete root.paDestroy;
      delete root.paRequestRender;
      delete root.dataset.paInitialised;
      delete root.dataset.paEnhanced;
      delete root.dataset.paAnimationEngine;
    };
  }

  function initialiseAll(scope = document) {
    if (scope.matches && scope.matches("[data-pa-root]")) initialise(scope);
    scope.querySelectorAll("[data-pa-root]").forEach(initialise);
  }

  window[engineKey] = { boot: initialiseAll };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialiseAll());
  } else {
    initialiseAll();
  }

  window.addEventListener("pageshow", () => initialiseAll());
  window.setTimeout(() => initialiseAll(), 120);

  document.addEventListener("shopify:section:load", (event) => initialiseAll(event.target));
  document.addEventListener("shopify:section:select", (event) => initialiseAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.matches && event.target.matches("[data-pa-root]")
      ? event.target
      : event.target.querySelector("[data-pa-root]");
    if (root && typeof root.paDestroy === "function") root.paDestroy();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
